/**
 * Where a Dialogue opens once the member has picked Voice or Text.
 *
 * Modality is chosen after the tap, never on the card or the Detail (guide §7.1,
 * §11), so every Start / Continue goes through the same two destinations:
 *
 *   Text  → /chat?module=DIALOGS&dialogueId=… (start) or &instanceId=… (continue)
 *   Voice → /coach/private?dialogue_id=…      (start) or ?dialogue_instance_id=…
 *
 * Continuing always goes by instance id: an Active Research Dialogue can arrive
 * with no `dialogue_id` at all (guide §6.1 rule 5), and starting again would
 * open a second instance instead of resuming the first.
 */
export const dialogueDestinations = ({ dialogueId, instanceId }) => {
  if (instanceId) {
    const id = encodeURIComponent(instanceId);
    return {
      text: `/chat?module=DIALOGS&instanceId=${id}`,
      voice: `/coach/private?dialogue_instance_id=${id}`,
    };
  }
  if (dialogueId) {
    const id = encodeURIComponent(dialogueId);
    return {
      text: `/chat?module=DIALOGS&dialogueId=${id}`,
      voice: `/coach/private?dialogue_id=${id}`,
    };
  }
  return null;
};

export default dialogueDestinations;
